var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.362)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BAD7A8",
    d: "m 12.420666,1043.6411 c -4.102211,1.0993 -8.3692979,-1.5243 -8.3692979,-1.5243 0,0 1.90285,-3.5171 5.2340081,-5.0505 l 0.071774,-0.017 c -3.5472713,-4.2747 -3.640217,-11.0216 -3.640217,-11.0216 0,0 6.7309368,0.093 11.0063168,3.6275 0.758509,0.6702 -0.196253,0.3398 0.02473,-0.043 1.529561,-3.3412 5.057957,-5.2502 5.057957,-5.2502 0,0 2.623591,4.2671 1.524369,8.3693 l 0.173442,-0.897 c 2.266666,-1.1192 4.548808,-1.2257 4.548808,-1.2257 0,0 -0.175136,4.184 -2.863749,6.8727 -1.675772,1.6757 -3.932485,2.375 -5.394922,2.6641 l 0.03907,-0.039 c -0.289441,1.4625 -0.988954,3.7173 -2.663549,5.3919 -2.688613,2.6886 -6.872621,2.8637 -6.872621,2.8637 0,0 0.09767,-2.3117 1.173925,-4.5466 z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 14.871094,1034.6816 a 0.50005,0.50005 0 0 0 -0.34961,0.8594 l 10.011719,10.0098 a 0.50005,0.50005 0 1 0 0.707031,-0.707 L 15.230469,1034.834 a 0.50005,0.50005 0 0 0 -0.359375,-0.1524 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#3c3b41",
    fillRule: "evenodd",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.632812,1033.1348 a 0.50005,0.50005 0 0 0 -0.505859,0.4414 l -0.736328,5.5547 a 0.50051745,0.50051745 0 0 0 0.992187,0.1328 l 0.736329,-5.5567 a 0.50005,0.50005 0 0 0 -0.486329,-0.5722 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#3c3b41",
    fillRule: "evenodd",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.855469,1038.6973 a 0.50005,0.50005 0 0 0 -0.03516,0 l -5.55664,0.7363 a 0.50052469,0.50052469 0 1 0 0.132812,0.9922 l 5.554688,-0.7363 a 0.50034345,0.50034345 0 1 0 -0.0957,-0.9961 z",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    fill: "#3c3b41",
    fillRule: "evenodd",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf1);
export default __webpack_public_path__ + "static/media/leaf-1.80c31bae8ce2b5f994df35583cb2d7a7.svg";
export { ForwardRef as ReactComponent };